import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

export const messageRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct message'),
    required: true,
    min: 1,
    max: 1024,
  });
};
